import {
  getDiscountForProduct,
  TShirtColor
} from '@containers/adminPanel/utils';
import { getDiscountedPrice } from '@features/checkout/utils';
import { Discount } from '@models/discount';
import { Product, ProductType, TShirtType } from '@models/product';
import { LocalItem, LocalTShirtItem } from '@store';

import {
  CartProduct,
  mapMugToCartProduct,
  mapTShirtToCartProduct
} from '../../../domain/mappers/cartProductMapper';

export const translateColorToBulgarian = (color: TShirtColor): string => {
  switch (color) {
    case TShirtColor.WHITE:
      return 'Бял';
    case TShirtColor.BLACK:
      return 'Черен';
    case TShirtColor.RED:
      return 'Червен';
    case TShirtColor.BLUE:
      return 'Син';
    case TShirtColor.DARK_BLUE:
      return 'Тъмносин';
    case TShirtColor.LIGHT_BLUE:
      return 'Светлосин';
    case TShirtColor.LIGHT_GREEN:
      return 'Светлозелен';
    case TShirtColor.DARK_GREEN:
      return 'Тъмнозелен';
    case TShirtColor.YELLOW:
      return 'Жълт';
    case TShirtColor.LIGHT_PINK:
      return 'Светлорозов';
  }
};

export const translateTypeToBulgarian = (type: TShirtType): string => {
  switch (type) {
    case TShirtType.MEN:
      return 'Мъжко';
    case TShirtType.WOMEN:
      return 'Дамско';
    case TShirtType.KIDS:
      return 'Детско';
    case TShirtType.OVERSIZED:
      return 'Oversized';
  }
};

export const addPriceToItems = async (
  cartItems: LocalItem[] | CartProduct[],
  products: Product[],
  activeDiscounts?: Discount[]
): Promise<CartProduct[]> => {
  const mappedItems: CartProduct[] = [];

  for await (const item of cartItems) {
    const product = products.find((p) => p.id === item.id);

    if (product && activeDiscounts) {
      const discount = getDiscountForProduct(product, activeDiscounts);
      const discountedPrice = getDiscountedPrice(product.price, discount);

      const tShirtItem = item as LocalTShirtItem;

      const mappedProduct =
        product.type === ProductType.TSHIRT
          ? mapTShirtToCartProduct(
              product,
              tShirtItem.color as TShirtColor,
              item.image,
              tShirtItem.size,
              tShirtItem.type,
              item.customizationNotes,
              discountedPrice
            )
          : mapMugToCartProduct(
              product,
              item.image,
              item.customizationNotes,
              discountedPrice
            );

      mappedItems.push(mappedProduct);
    }
  }

  return mappedItems;
};
